import React, { useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Dialog, DialogContent, DialogActions } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FilterDoubleButtons from '#component/general/filter-double-buttons.js/filter-double-buttons';
import { OverlayProvider } from './hooks/useOverlayContext';
import { useResetToAppliedFilter } from './hooks';
import { StyledDialogTitle, CloseButton, FilterTitle } from './filter.styles';

const FilterMobile = ({ open, setModalOpen, handleFetchFilterData, children }) => {
  const pristine = useSelector(state => state.listFilter?.pristine, shallowEqual);
  const filterRef = useRef(null);

  const resetToAppliedFilter = useResetToAppliedFilter();

  const handleClose = () => {
    if (!pristine) {
      resetToAppliedFilter();
    }
    setModalOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = event => {
      const isInsideFilter = filterRef.current && filterRef.current.contains(event.target);
      const isInsideAutoComplete = event.target?.parentNode?.id?.startsWith('filter-');
      const isInsideSearch = event.target?.id?.startsWith('list-search') ||
        event.target?.parentNode?.id?.startsWith('list-search');

      const isClickOutside = !isInsideFilter && !isInsideAutoComplete && !isInsideSearch;

      if (isClickOutside) {
        setModalOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setModalOpen]);

  const handleApply = () => {
    handleFetchFilterData();
    setModalOpen(false);
  };

  return (
    <OverlayProvider>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        aria-label="Filter container"
        ref={filterRef}
      >
        <StyledDialogTitle>
          <CloseButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </CloseButton>
          <FilterTitle fontWeight={500}>Filter Options</FilterTitle>
        </StyledDialogTitle>
        <DialogContent style={{ paddingBottom: '35px' }}>
          {children}
        </DialogContent>
        <DialogActions>
          <FilterDoubleButtons
            firstLabel="cancel"
            secondLabel="apply"
            onFirstButtonClick={handleClose}
            onSecondButtonClick={handleApply}
            isSecondButtonDisabled={pristine}
          />
        </DialogActions>
      </Dialog>
    </OverlayProvider>
  );
};

export default FilterMobile;
